module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAMFJREFUKBVjYCATMK5du03m998fSf8ZmWRAZjD+//+fgZHxorgI/zxHR8cfuMxlXL5yfT0DE6M0ugImRoYrfxhZN6KLczL+/BIUFPSWcfnqDbPQJQny///dyERQERYFjAxMrmRp/M/IyMUCM9DHwxnM3LJjLwOIzcPDA5OC01++fGEAyYMAeX4EaiTLqSAbB8Kp////AVlNCmD89/8HEyPj/0OkaAKrZWLYzghibNu2jf3v37/MxBjw/fv3P2FhYb8AELZHWXfIk+kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tuku.png
// module id = H4Cp
// module chunks = 1